import apiUtils from '../apiUtils';
import HTTPClient from '../HTTPClient';

const getAddressByID = async id => {
    const uri = `${apiUtils.getBaseUri()}/users/current/addresses/${id}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load address by id (${response.status})`);
    }

    return await response.json();
};

const getAddressSuggestions = async (userId, dto) => {
    // predefined measure for preventing exposing user sensitive data in the URL
    const userData = userId ? 'current' : 'anonymous';

    const uri = `${apiUtils.getBaseUri()}/users/${userData}/addresses/verification`;
    const response = await HTTPClient().postJson(uri, dto);

    if (!response.ok) {
        throw new Error(`Unable to load address suggestions (${response.status})`);
    }
    return await response.json();
};

export default {
    getAddressByID,
    getAddressSuggestions,
};
